module.exports = __webpack_public_path__ + "media/assets/icons/emojione-monotone_beating-heart-b5daf2d1293964bf9995b0b78a73af5a.svg";